import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState, type JSX, type ReactNode } from 'react';
import { FormInputSearch, IconTile, Modal } from 'shared/components';
import { EmptyState } from 'shared/components/empty-states';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface RulePickerItem<TSlug extends string> {
  category: string;
  slug: TSlug;
  title: string;
  description: string;
  icon: JSX.Element;
}
export interface RulePickerModalProps<TSlug extends string> {
  title: ReactNode;
  categoryOrder: readonly string[];
  items: RulePickerItem<TSlug>[];
  onSelect: (slug: TSlug) => void;
  onClose: () => void;
  dataTest: string;
  opened: boolean;
}
export function RulePickerModal(t0) {
  const $ = _c(42);
  const {
    title,
    categoryOrder,
    items,
    onSelect,
    onClose,
    dataTest,
    opened
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [query, setQuery] = useState("");
  let t1;
  let t2;
  if ($[0] !== opened) {
    t1 = () => {
      if (!opened) {
        setQuery("");
      }
    };
    t2 = [opened];
    $[0] = opened;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let T0;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== categoryOrder || $[4] !== dataTest || $[5] !== items || $[6] !== onClose || $[7] !== onSelect || $[8] !== opened || $[9] !== query || $[10] !== t || $[11] !== title) {
    const normalizedQuery = query.trim().toLocaleLowerCase();
    const groupedItems = new Map();
    items.forEach(item => {
      const matchesQuery = normalizedQuery === "" || t(item.title).toLocaleLowerCase().includes(normalizedQuery) || t(item.description).toLocaleLowerCase().includes(normalizedQuery);
      if (!matchesQuery) {
        return;
      }
      const categoryItems = groupedItems.get(item.category) ?? [];
      categoryItems.push(item);
      groupedItems.set(item.category, categoryItems);
    });
    const emptyStateTitle = normalizedQuery ? t("dashboard.list.empty_search.title", {
      search: query.trim()
    }) : t("dashboard.list.empty_filter.title");
    T0 = Modal;
    t5 = title;
    t6 = opened;
    t7 = onClose;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = {
        showCloseButton: false
      };
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    let t10;
    if ($[21] !== t) {
      t10 = t("global.search");
      $[21] = t;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    let t11;
    let t12;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = event => setQuery(event.target.value);
      t12 = () => setQuery("");
      $[23] = t11;
      $[24] = t12;
    } else {
      t11 = $[23];
      t12 = $[24];
    }
    let t13;
    if ($[25] !== t) {
      t13 = t("global.search");
      $[25] = t;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    const t14 = `${t13}...`;
    if ($[27] !== query || $[28] !== t10 || $[29] !== t14) {
      t9 = <FormInputSearch aria-label={t10} onChange={t11} onClear={t12} placeholder={t14} value={query} />;
      $[27] = query;
      $[28] = t10;
      $[29] = t14;
      $[30] = t9;
    } else {
      t9 = $[30];
    }
    t3 = "border-border-200 tablet:h-128 tablet:flex-none min-h-0 flex-1 overflow-y-auto rounded-md border p-2";
    t4 = groupedItems.size === 0 ? <EmptyState className="h-full py-0" title={emptyStateTitle} description={t("dashboard.list.empty_search.description")} /> : categoryOrder.map(category => {
      const categoryItems_0 = groupedItems.get(category);
      if (!categoryItems_0) {
        return null;
      }
      return <section key={category}><h3 className="text-text-tertiary flex h-6 items-end justify-center text-sm uppercase">{t(category)}</h3>{categoryItems_0.map(item_0 => <button className="hover:bg-bg-tertiary focus-visible:focus-ring-primary transition-base flex w-full items-start gap-3 rounded-lg px-4 py-2 text-left outline-none" data-test={`${dataTest}-${item_0.slug}`} key={item_0.slug} onClick={() => onSelect(item_0.slug)} type="button"><IconTile aria-hidden="true" tone="white">{item_0.icon}</IconTile><span className="flex min-w-0 flex-col gap-1"><span className="text-text-primary text-base font-medium">{t(item_0.title)}</span><span className="text-text-tertiary text-sm">{t(item_0.description)}</span></span></button>)}</section>;
    });
    $[3] = categoryOrder;
    $[4] = dataTest;
    $[5] = items;
    $[6] = onClose;
    $[7] = onSelect;
    $[8] = opened;
    $[9] = query;
    $[10] = t;
    $[11] = title;
    $[12] = T0;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t10;
  if ($[31] !== t3 || $[32] !== t4) {
    t10 = <div className={t3}>{t4}</div>;
    $[31] = t3;
    $[32] = t4;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  let t11;
  if ($[34] !== T0 || $[35] !== t10 || $[36] !== t5 || $[37] !== t6 || $[38] !== t7 || $[39] !== t8 || $[40] !== t9) {
    t11 = <T0 title={t5} opened={t6} onClose={t7} popupProps={t8} headerContent={t9}>{t10}</T0>;
    $[34] = T0;
    $[35] = t10;
    $[36] = t5;
    $[37] = t6;
    $[38] = t7;
    $[39] = t8;
    $[40] = t9;
    $[41] = t11;
  } else {
    t11 = $[41];
  }
  return t11;
}